import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const AppleDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 314" transform="translate(-524.68 -144.644)">
      <rect
        data-name="\u9577\u65B9\u5F62 730"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(524.68 144.644)"
      />
      <path data-name="\u9577\u65B9\u5F62 731" fill="#fff" d="M530.961 184.298h131.78v74.423h-131.78z" />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 313">
        <path
          data-name="\u30D1\u30B9 1019"
          d="M662.714 184.3v-18.013a14.3 14.3 0 00-14.283-14.309h-14.1v1.922a7.579 7.579 0 01-7.572 7.586h-59.008a7.58 7.58 0 01-7.573-7.586v-1.918h-14.935a14.3 14.3 0 00-14.282 14.309V184.3z"
          fill="#fff"
        />
      </g>
      <path
        data-name="\u30D1\u30B9 1020"
        d="M530.961 256.872v167.012a14.308 14.308 0 0014.308 14.308h103.1a14.308 14.308 0 0014.308-14.308V256.872z"
        fill="#fff"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 732"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(578.386 430.669)"
      />
      <path data-name="\u7DDA 1" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M531.087 403.678h131.364" />
      <path data-name="\u7DDA 2" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M531.087 186.029h131.364" />
      <circle
        data-name="\u6955\u5186\u5F62 452"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(539.628 410.163)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 453"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(564.791 410.163)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 454"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(589.954 410.163)"
        fill="#1784eb"
      />
      <circle
        data-name="\u6955\u5186\u5F62 455"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(615.117 410.163)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 456"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(640.28 410.163)"
        fill="#9e9e9e"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 733"
        width={121.346}
        height={121.35}
        rx={10.624}
        transform="translate(536.764 211.978)"
        fill="#c0ebf9"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 734"
        width={28.094}
        height={9.871}
        rx={4.935}
        transform="translate(627.101 195.41)"
        fill="#e5e5e5"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 735"
        width={116.48}
        height={11.384}
        rx={5.692}
        transform="translate(538.426 167.509)"
        fill="#e7e7e7"
      />
      <path data-name="\u9577\u65B9\u5F62 736" fill="#424242" d="M537.656 191.889h15.69v15.69h-15.69z" />
      <path data-name="\u9577\u65B9\u5F62 737" fill="#eee" d="M558.007 193.484h34.371v3.938h-34.371z" />
      <path data-name="\u9577\u65B9\u5F62 738" fill="#eee" d="M558.007 200.182h22.077v3.938h-22.077z" />
      <rect
        data-name="\u9577\u65B9\u5F62 739"
        width={28.094}
        height={9.871}
        rx={4.935}
        transform="translate(628.169 346.012)"
        fill="#e5e5e5"
      />
      <path data-name="\u9577\u65B9\u5F62 740" fill="#424242" d="M538.725 342.492h15.69v15.69h-15.69z" />
      <path data-name="\u9577\u65B9\u5F62 741" fill="#eee" d="M559.075 344.087h34.371v3.938h-34.371z" />
      <path data-name="\u9577\u65B9\u5F62 742" fill="#eee" d="M559.075 350.785h22.077v3.938h-22.077z" />
      <path data-name="\u9577\u65B9\u5F62 743" fill="#e5e5e5" d="M538.717 363.717h55.928v39.312h-55.928z" />
      <path data-name="\u9577\u65B9\u5F62 744" fill="#e5e5e5" d="M599.729 363.717h55.928v39.312h-55.928z" />
    </g>
  </Root>
);

const Root = styled('svg')();

export default AppleDevice11;
